import RangeSlider from './RangeSlider';

const els = document.querySelectorAll('.js-range-slider');

for (let el of els) {
    new RangeSlider(el);
}
